import { PaymentBlock } from '../components/vdp/payment-block.vue';
import { PaymentBlockV3 } from '../components/vdp/payment-block-v3.vue';
Vue.component('payment-block', PaymentBlock);
Vue.component('payment-block-v3', PaymentBlockV3);
import RoundSlider from 'vue-round-slider';
Vue.component('vue-round-slider', RoundSlider);
